module.exports = __webpack_public_path__ + "static/media/shopping-cart.ca664e09.svg";